import React, { useState, useEffect, useCallback } from "react";
import AdminModal from "../adminModal";
import AdminTabs from "../adminTabs";
import { ThreeCircles } from "react-loader-spinner";
import GetAPI from "../../APICalls/GetAPI";
import PutAPI from "../../APICalls/PutAPI";
import PostAPI from "../../APICalls/PostAPI";
import StatusUpdatePopup from "./StatusUpdatePopup";
import "./Corporate.css";
import CreateLeadModal from "./CreateLeadModal";
import { handleCorporateChefsData } from "../ChefVerification/services";

const Corporate = () => {
  const [loading, setLoading] = useState(false);
  const [notVerified, setNotVerified] = useState(true);
  const [activeTab, setActiveTab] = useState("Leads");
  const [activeData, setActiveData] = useState([]);
  const [showCreateLead, setShowCreateLead] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [selectedRowData, setSelectedRowData] = useState(null);
  const [statusOptions, setStatusOptions] = useState([]);
  const [corporateMenu, setCorporateMenu] = useState([]);
  const [chefs, setChefs] = useState([]);
  const [lastUserID, setLastUserID] = useState(null);

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const handleVerified = useCallback((value) => setNotVerified(value), []);

  let environment = process.env.REACT_APP_NODE_ENV;
  let corporateApi, corporateMenuApi, fetchChefDetails;
  if (environment === "PRODUCTION") {
    corporateApi = process.env.REACT_APP_PROD_CORPORATE;
    corporateMenuApi = process.env.REACT_APP_PROD_CORPORATEMENU;
    fetchChefDetails = process.env.REACT_APP_PROD_USERAPI;
  } else {
    corporateApi = process.env.REACT_APP_DEV_CORPORATE;
    corporateMenuApi = process.env.REACT_APP_DEV_CORPORATEMENU;
    fetchChefDetails = process.env.REACT_APP_DEV_USERAPI;
  }

  const getCorporateDataViaStatus = () => {
    let completeAPI = corporateApi + "?status=" + activeTab;

    GetAPI(completeAPI)
      .then((res) => {
        if (res && res.data && res.data.statusCode === 200) {
          setActiveData(res.data.body);
          getCorporateMenus();
        } else {
          alert("Failed to get data");
          console.log(res);
        }
      })
      .catch((e) => {
        console.error(e);
        alert("Failed to get data");
      });
  };

  const getCorporateMenus = () => {
    let completeAPI = corporateMenuApi + "?type=ALL";

    GetAPI(completeAPI)
      .then((res) => {
        if (res && res.data && res.data.statusCode === 200) {
          setCorporateMenu(res.data.body);
        } else {
          console.log(res);
        }
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    getCorporateDataViaStatus(activeTab);
  }, [activeTab]);

  const closeCreateModal = () => {
    setShowCreateLead(false);
  };

  const handleRowClick = (item) => {
    setSelectedRowData(item);

    let options = [];
    if (item.status === "Leads") {
      options = ["Contacted", "Dropped"];
    } else if (item.status === "Contacted") {
      options = ["Onboarded", "Dropped"];
    } else if (item.status === "Onboarded") {
      options = ["Chef assigning", "Dropped"];
    }

    setStatusOptions(options);
    setShowPopup(true);
  };

  const handleDismiss = () => {
    setShowPopup(false);
    setSelectedRowData(null);
  };

  const confirmStatusUpdate = (updatedData, type) => {
    setLoading(true);
    let corporate;
    if (environment === "PRODUCTION") {
      corporate = process.env.REACT_APP_PROD_CORPORATE;
    } else {
      corporate = process.env.REACT_APP_DEV_CORPORATE;
    }

    if (
      (updatedData.status.toUpperCase() === "ONBOARDED" && type === "NEW") ||
      (updatedData.status.toUpperCase() === "CHEFASSIGNING" && type === "NEW")
    ) {
      PostAPI(corporate, updatedData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            window.location.reload();
            alert("Succesfully updated!!!");
          } else {
            alert("Failed to update!!!");
          }
        })
        .catch((e) => {
          console.error(e);
          alert("Failed to update!!!");
        });
    } else {
      PutAPI(corporate, updatedData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            window.location.reload();
            alert("Succesfully updated!!!");
          } else {
            alert("Failed to update!!!");
          }
        })
        .catch((e) => {
          console.error(e);
          alert("Failed to update!!!");
        });
    }
    setLoading(false);
    setShowPopup(false);
  };

  useEffect(() => {
    setLoading(true);
      handleCorporateChefsData(setChefs, setLoading, setLastUserID, lastUserID);
  }, []);
  
  useEffect(() => {
    if (lastUserID !== "" && lastUserID !== null) {
      handleCorporateChefsData(setChefs, setLoading, setLastUserID, lastUserID);
    }
  }, [lastUserID]); 
  

  return (
    <div>
      <AdminTabs />
      {notVerified ? (
        <AdminModal handleVerified={handleVerified} />
      ) : (
        <>
          {showCreateLead ? (
            <CreateLeadModal
              showModal={showCreateLead}
              handleClose={closeCreateModal}
            />
          ) : null}
          {loading ? (
            <div className="spinnerContainer">
              <div className="spinner">
                <ThreeCircles
                  color="blue"
                  height={110}
                  width={110}
                  ariaLabel="three-circles-rotating"
                />
              </div>
            </div>
          ) : (
            <div className="corporate-dashboard">
              <h2>Corporate Client Dashboard</h2>
              <div className="tabs">
                <ul>
                  <li
                    className={activeTab === "Leads" ? "active-tab" : ""}
                    onClick={() => handleTabClick("Leads")}
                  >
                    Leads
                  </li>
                  <li
                    className={activeTab === "Contacted" ? "active-tab" : ""}
                    onClick={() => handleTabClick("Contacted")}
                  >
                    Contacted
                  </li>
                  <li
                    className={activeTab === "Onboarded" ? "active-tab" : ""}
                    onClick={() => handleTabClick("Onboarded")}
                  >
                    Onboarded
                  </li>
                  <li
                    className={
                      activeTab === "ChefAssigning" ? "active-tab" : ""
                    }
                    onClick={() => handleTabClick("ChefAssigning")}
                  >
                    Chef assigning
                  </li>
                  <li
                    className={activeTab === "Dropped" ? "active-tab" : ""}
                    onClick={() => handleTabClick("Dropped")}
                  >
                    Dropped
                  </li>
                </ul>
              </div>
              <table className="corporate-table">
                <thead>
                  <tr>
                    <th>Name</th>
                    <th>Phone number</th>
                    <th>Quantity</th>
                    <th>Meal</th>
                    <th>Preference</th>
                    <th>Cuisine</th>
                    {activeTab === "Contacted" ? <th>Conversion</th> : null}
                  </tr>
                </thead>
                <tbody>
                  {activeData.map((item) => (
                    <tr key={item.id} onClick={() => handleRowClick(item)}>
                      <td>{item.companyName}</td>
                      <td>{item.phoneNumber}</td>
                      <td>{item.quantity}</td>
                      <td>
                        <button className="meal-button">{item.menuName}</button>
                      </td>
                      <td>{item.preference}</td>
                      <td>{item.cuisine}</td>
                      {activeTab === "Contacted" ? (
                        <td>{item.conversion}</td>
                      ) : null}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </>
      )}

      {/* Popup for status update */}
      {showPopup && (
        <StatusUpdatePopup
          show={showPopup}
          confirmStatusUpdate={confirmStatusUpdate}
          selectedRow={selectedRowData}
          currentStatus={activeTab}
          chefs={chefs}
          handleDismiss={handleDismiss}
          statusOptions={statusOptions}
          corporateMenu={corporateMenu}
        />
      )}
    </div>
  );
};

export default Corporate;
